// extracted by mini-css-extract-plugin
module.exports = {"label":"Label-module--label--ELX9P","required":"Label-module--required--27UqE"};